module.exports = __webpack_public_path__ + "img/ruinas.e98892be.jpg";